<!--
 * @Descripttion: 联系我们的全局悬浮引导组件
 * @Author: 陈文湘
 * @Date: 2020-07-16 09:03:11
 * @LastEditors: Please set LastEditors
 * @FilePath: \kuaio\src\components\contact\contact.vue
-->
<!-- 组件说明 -->
<template>
    <div class="contact">
        <ul class="contact_ul">
            <li
                class="contact_ul_li"
                :class="hoverID === 0 ? 'hoverClass' : ''"
                @mouseover="hoverFunc(0)"
                @mouseout="outFun"
            >
                <div class="img_box">
                    <img v-if="hoverID === 0" src="./img/gift_ed.png" alt="" />
                    <img v-else src="./img/gift.png" alt="" />
                </div>
                <span>福利</span>
                <!-- <svg class="icon font24" aria-hidden="true" slot="reference">
          <use xlink:href="#iconqiyeweixinkefu"></use>
        </svg> -->
                <!-- <i class="iconfont iconqiyeweixin font24"></i> -->
            </li>
            <li
                class="contact_ul_li"
                :class="hoverID === 1 ? 'hoverClass' : ''"
                @mouseover="hoverFunc(1)"
                @mouseout="outFun"
            >
                <div class="img_box">
                    <img
                        v-if="hoverID === 1"
                        src="./img/server_ed.png"
                        alt=""
                    />
                    <img v-else src="./img/server.png" alt="" />
                </div>
                <span>客服</span>
                <!-- <svg class="icon font24" aria-hidden="true" slot="reference">
          <use xlink:href="#iconqiyeweixinkefu"></use>
        </svg> -->
                <!-- <i class="iconfont iconqiyeweixin font24"></i> -->
            </li>
            <li
                class="contact_ul_li"
                :class="hoverID === 2 ? 'hoverClass' : ''"
                @mouseover="hoverFunc(2)"
                @mouseout="outFun"
            >
                <!-- <svg class="icon font24" aria-hidden="true" slot="reference">
          <use xlink:href="#iconweixin1"></use>
        </svg> -->
                <!-- <i class="iconfont iconweixinFF font24"></i> -->
                <div class="img_box" style="width: 17px">
                    <img v-if="hoverID === 2" src="./img/phone_ed.png" alt="" />
                    <img v-else src="./img/phone.png" alt="" />
                </div>
                <span>手机端</span>
            </li>

            <li
                class="contact_ul_li curp"
                :class="hoverID === 3 ? 'hoverClass' : ''"
                @mouseover="hoverFunc(3)"
                @mouseout="outFun"
                v-show="isToTop"
                @click="toTop"
            >
                <div class="img_box" style="width: 17px">
                    <img v-if="hoverID === 3" src="./img/gotop_ed.png" alt="" />
                    <img v-else src="./img/gotop.png" alt="" />
                </div>
            </li>

            <div class="suspension">
                <div
                    class="kuaio-gift"
                    v-show="hoverID === 0"
                    style="
                        width: 252px;
                        padding: 25px 10px 15px 10px;
                        background: rgba(255, 255, 255, 1);
                        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
                        border-radius: 4px;
                    "
                >
                    <p class="title fw-bold mb-10">快哦用户福利</p>
                    <div class="gift-content">
                        <div class="icon">
                            <img src="./img/gift_content_1.png" alt="" />
                        </div>
                        <div>
                            <p class="gift-content-title">加客服微信</p>
                            <p class="gift-content-descript">
                                送<span class="c-danger">10</span>个产品检测次数
                            </p>
                        </div>
                    </div>
                    <div class="gift-content">
                        <div style="width: 20px" class="icon">
                            <img src="./img/gift_content_2.png" alt="" />
                        </div>
                        <div>
                            <p class="gift-content-title">邀请好友注册</p>
                            <p class="gift-content-descript">
                                送<span class="c-danger">20</span>个产品检测数
                            </p>
                        </div>
                    </div>
                    <div class="gift-content">
                        <div style="width: 18px" class="icon">
                            <img src="./img/gift_content_3.png" alt="" />
                        </div>
                        <div>
                            <p class="gift-content-title">
                                分享您店铺被投诉的经历
                            </p>
                            <p class="gift-content-descript">
                                送<span class="c-danger">50</span>个产品检测次数
                            </p>
                        </div>
                    </div>
                    <div class="gift-content">
                        <div style="width: 20px" class="icon">
                            <img src="./img/gift_content_4.png" alt="" />
                        </div>
                        <div>
                            <p class="gift-content-title">
                                被投诉违禁词（快哦词库无）
                            </p>
                            <p class="gift-content-descript">
                                送<span class="c-danger">50</span>个产品检测
                            </p>
                        </div>
                    </div>
                    <div
                        style="
                            width: 100%;
                            height: 1px;
                            background: #eee;
                            margin-top: 15px;
                        "
                    ></div>
                    <div
                        style="color: #ff5500; text-align: center"
                        class="pt-15"
                    >
                        【请添加客服微信领取福利】
                    </div>
                </div>
                <div
                    v-show="hoverID === 1"
                    style="
                        width: 180px;
                        text-align: center;
                        padding: 16px 30px;
                        background: rgba(255, 255, 255, 1);
                        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
                        border-radius: 4px;
                    "
                >
                    <p
                        class="font14 fontWB mb-15 mt-5"
                        style="text-align: center"
                    >
                        扫码添加客服微信
                    </p>
                    <img
                        src="https://cbu01.alicdn.com/img/ibank/O1CN01eaZNOd1EsSBSMaMuW_!!2216950060407-0-cib.jpg"
                        style="text-align: center; margin: 0 auto; width: 120px"
                        alt=""
                    />
                    <div class="mt-10" style="text-align: left">
                        <p class="font14 fontWB py-8">客服电话</p>
                        <p class="font14 color333 fontWB pb-8">177-5912-6083</p>
                        <p class="color66 font12">工作日：08:30-21:00</p>
                    </div>
                </div>
                <div
                    v-show="hoverID === 2"
                    style="
                        width: 180px;
                        text-align: center;
                        padding: 16px 30px;
                        background: rgba(255, 255, 255, 1);
                        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
                        border-radius: 4px;
                    "
                >
                    <p
                        class="font14 fontWB mb-15 mt-5"
                        style="text-align: center"
                    >
                        扫码关注公众号
                    </p>
                    <img
                        src="./img/wechat.png"
                        style="text-align: center; margin: 0 auto"
                        alt=""
                    />
                    <div class="mt-10" style="color: #ff5500">
                        <p class="font14">手机端检测</p>
                        <p class="font14 pt-5">文字&图片违禁词</p>
                    </div>
                </div>
            </div>
        </ul>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        return {
            isToTop: false,
            hoverID: "",
        };
    },
    //监控data中的数据变化
    watch: {},
    //监听属性 类似于data概念
    computed: {},
    methods: {
        /**
         * @name: toTop
         * @Description: 回到顶部,调用父组件的回到顶部
         * @param {}
         * @return:
         * @Author: 陈文湘
         */

        toTop() {
            this.$emit("click-toTop");
        },
        hoverFunc(v) {
            this.hoverID = v;
        },
        outFun() {
            this.hoverID = 10;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
};
</script>

<style lang="scss" scoped>
//@import url()
.contact {
    .contact_ul {
        width: 52px;
        // height: 160px;

        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        position: relative;

        .contact_ul_li {
            position: relative;
            &:first-child {
                padding-top: 8px;
                // background: red;
            }
            &::after {
                position: absolute;
                bottom: 0;
                left: 25%;
                content: "";
                background: #eee;
                width: 50%;
                height: 1px;
            }

            width: 54px;
            height: 64px;
            color: #9b9ea0;
            padding-top: 5px;
            padding-bottom: 5px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: center;
            cursor: pointer;
            .img_box {
                margin: 0 auto;
                display: block;
                width: 22px;
                img {
                    display: block;
                    width: 100%;
                }
            }

            span {
                display: block;
                padding: 4px 0;
                font-size: 14px;
                text-align: center;
            }
        }
        .curp {
            &::after {
                position: absolute;
                bottom: 0;
                left: 25%;
                content: "";
                background: #fff;
                width: 50%;
                height: 1px;
            }
        }
        .hoverClass {
            background: rgba(29, 100, 245, 1);
            color: #ffffff;
            &::after {
                position: absolute;
                bottom: 0;
                left: 25%;
                content: "";
                background: rgba(29, 100, 245, 1);
                width: 50%;
                height: 1px;
            }
        }
    }
    .suspension {
        // width: 136px;
        // height: 172px;
        // background: rgba(255, 255, 255, 1);
        // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
        .kuaio-gift {
            font-size: 14px;
            .title {
                text-align: center;
            }
            .gift-content {
                padding-top: 5px;
                padding-bottom: 5px;
                padding-left: 50px;
                margin-bottom: 5px;
                position: relative;
                .icon {
                    position: absolute;
                    left: 10px;
                    top: 14px;
                    width: 25px;
                    height: 25px;
                    line-height: 25px;
                    // background: red;
                    img {
                        margin: 0 auto;
                        display: block;
                        width: 100%;
                    }
                }
                .gift-content-title {
                    padding: 5px 0;
                    color: #333;
                }
                .gift-content-descript {
                    color: #9b9ea0;
                    font-size: 12px;
                }
            }
        }
        border-radius: 4px;
        position: absolute;
        right: 60px;
        top: 0;
        img {
            // width: 100%;
            // height: 100%;
            margin-top: -8px;
            margin-right: -8px;
        }
        .kfdhClass {
            width: 170px;
            height: 103px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
            border-radius: 4px;
            padding: 20px;
            margin-top: 65px;
        }
    }
}
</style>
